import React from 'react'
import { useUpdateLoaMutation } from '../../redux/Api/CampaignManagment/cMLoaApiSlice';
import { cMCampaignsApi } from '../../redux/Api/CampaignManagment/cMCampaignsApiSlice';
import {
    customerCampaignPlatformApi,
    useUpdateCustomerCampaignPlatformMutation
} from '../../redux/Api/CampaignManagment/cMCustomerCampaignPlatformApiSlice';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Button, Input, Modal } from 'antd';
import CustomersDropdown from '../CustomersDropdown';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';

const EditCreateLOA = ({ state, open, setOpen, campaign }) => {
    const [updateLoa, { isLoading: isUpdating }] = useUpdateLoaMutation()
    const [updateEntryLoa, { isLoading: isEntryUpdating }] =
        useUpdateCustomerCampaignPlatformMutation()
    const dispatch = useDispatch()

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            campaign_loa_dropbox_url: campaign?.campaign_loa_dropbox_url || "",
            customer:
                typeof campaign?.customer === 'object'
                    ? campaign?.customer?.id || null
                    : campaign?.customer || null,
            campaign:
                campaign?.campaign?.id ||
                campaign?.campaign ||
                campaign?.id ||
                null
        },
        validationSchema: Yup.object({
            campaign_loa_dropbox_url: Yup.string().required(`Campaign LOA Dropbox URL is required`),
            customer: Yup.number().nullable(),
            campaign: Yup.number().nullable(),
        }),
        onSubmit: async (values) => {
            try {
                if (state === 'edit' && campaign?.id) {
                    await updateEntryLoa({
                        id: campaign.id,
                        data: {
                            campaign_loa_dropbox_url: values.campaign_loa_dropbox_url
                        }
                    }).unwrap()
                } else {
                    await updateLoa(values).unwrap()
                }
                dispatch(cMCampaignsApi.util.invalidateTags(['Campaign']))
                dispatch(
                    customerCampaignPlatformApi.util.invalidateTags([
                        'CustomerCampaignPlatform'
                    ])
                )
                toast.success('LOA updated successfully')
                setOpen(false)
            } catch (error) {
                if (error?.data) {
                    const errorMessages = Object.values(error.data).flat()
                    errorMessages.forEach(message => {
                        toast.error(message)
                    })
                } else {
                    toast.error('Failed to save LOA')
                }
            }
        }
    });

    const handleSubmit = async () => {
        const errors = await validation.validateForm();
        if (Object.keys(errors).length !== 0) {
            Object.keys(errors).forEach((key) => {
                toast.error(errors[key]);
            });
            return;
        }
        validation.handleSubmit();
    }

    return (
        <Modal
            className='customModal'
            open={open}
            title={state === "edit" ? "Change LOA for Customer" : "Add LOA for Customer"}
            onCancel={() => setOpen(false)}
            footer={[
                <Button key="back" onClick={() => setOpen(false)}>
                    Cancel
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    loading={isUpdating || isEntryUpdating}
                    onClick={handleSubmit}
                >
                    Submit
                </Button>
            ]}
        >
            {state === "create" ?
                <>
                    <CustomersDropdown
                        onChange={e => { validation.setFieldValue("customer", e) }}
                        onBlur={validation.handleBlur}
                    />
                </> : null
            }
            <div className=" mb-3">
                <label className="" >LOA Dropbox URL</label>
                <Input
                    type="text"
                    name='campaign_loa_dropbox_url'
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.campaign_loa_dropbox_url}
                />
            </div>
            <div className='flex flex-col'>
                {Object.keys(validation.errors).map((key) => (
                    <p key={key} className='text-danger'>{validation.errors[key]}</p>
                ))}
            </div>
        </Modal>
    )
}

export default EditCreateLOA